<template>
  <section>
    <div class="tb-loading-header">
      <vue-content-loading :width="600" :height="50">
        <rect x="0" y="0" rx="2" ry="2" width="100%" height="50" />
      </vue-content-loading>
      <div v-for="item in items" :key="item">
        <vue-content-loading class="table-row" :width="600" :height="20">
          <rect x="0" y="0" rx="2" ry="2" width="100%" height="20" />
        </vue-content-loading>
      </div>
    </div>
  </section>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  name: 'RankingLoading',
  components: {
    VueContentLoading,
  },
  props: {
    items: {
      type: Number,
      default: 10,
    },
  },
};
</script>

<style lang="scss" scoped>
section {
  // background: #f7f6f8;
  height: auto;

  .loading-header {
    width: 65%;
    height: auto;
    margin-bottom: 15px;
  }

  .tb-loading-header {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
  }
  .table-header {
    width: 100%;
    height: 20px;
    margin-bottom: 10px;
  }
}

@media all and (min-width: 300px) and (max-width: 1000px) {
  section {
    max-height: 100vh;
    min-height: 100vh !important;
    opacity: 0;
    display: none;
  }
}
</style>
